module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a4218323544d10ac955ba13f86ea232e.png";